var Progress = function Progress(_ref) {
  var spacing = _ref.spacing,
      colors = _ref.colors,
      radii = _ref.radii,
      fontSizes = _ref.fontSizes;
  return {
    height: spacing.xxsmall,
    backgroundColor: {
      bar: colors.elements.backgroundAndDisabled
    },
    border: {
      radius: radii.small
    },
    label: {
      font: {
        size: fontSizes.xsmall
      }
    }
  };
};

export default Progress;